import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core';

// COMPONENTS
import Link from '@/components/Link';

// STYLES
import { Wrapper, TitleContainer, Container, PriceSection, ButtonStyled } from './styles';

const InfoCard = ({ data, type }) => {
  const theme = useTheme();

  return (
    <Wrapper type={type} className="info-card">
      <TitleContainer>
        {data.title && <p className="p3 title">{data.title}</p>}
        {data.subtitle && <p className="p4">{data.subtitle}</p>}
      </TitleContainer>

      <Container>
        {data.price && (
          <PriceSection>
            <span className="price">${data.price.amount}</span>
            <span className="period">/{data.price.period}</span>
          </PriceSection>
        )}

        <ButtonStyled
          variant={theme.partnerStyles ? 'contained' : 'outlined'}
          color="primary"
          component={Link}
          {...data.button}
        >
          {data.button.text}
        </ButtonStyled>
      </Container>
    </Wrapper>
  );
};

InfoCard.defaultProps = {
  type: 'default', // default | dark
};

InfoCard.propTypes = {
  data: PropTypes.object,
  type: PropTypes.string,
};

export default React.memo(InfoCard);
